import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  Renderer2,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appEmailTip]',
})
export class EmailTipDirective implements OnChanges {
  @Input() appEmailTip?: string;
  @Input() searchTerm?: string | null;
  @Output() copyEmail = new EventEmitter<string>();

  @HostListener('click', []) onClick() {
    const [domain] = this.searchTerm?.split('@') || [];
    this.copyEmail.emit((domain || '') + (this.appEmailTip || ''));
  }

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(): void {
    this.setInnerHtmlToTransformedValue();
    this.setVisibilityIfSearchTermIsInEmailTipValue();
  }

  private setInnerHtmlToTransformedValue(): void {
    this.renderer.setProperty(
      this.el.nativeElement,
      'innerHTML',
      this.transform(this.searchTerm, this.appEmailTip),
    );
  }

  private setVisibilityIfSearchTermIsInEmailTipValue(): void {
    const emailTipValue = this.appEmailTip?.toLowerCase() || '';
    const searchTerm = this.searchTerm || '';

    if (searchTerm) {
      const [userId, domain] = searchTerm.toLowerCase().split('@');
      const searchTermIncludesAtSymbol = searchTerm.includes('@');

      // hide if no @ symbol or no userId
      if (!searchTermIncludesAtSymbol || !userId?.length) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        return;
      }

      // show if no domain after @ symbol
      if (!domain) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
        return;
      }

      // hide if the search term is the same as the domain
      if (emailTipValue.replace('@', '') === domain) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
        return;
      }

      // show if the search term is in the email tip bold value
      const isSearchTermInEmailTipValue = emailTipValue.includes(domain);
      this.renderer.setStyle(
        this.el.nativeElement,
        'display',
        isSearchTermInEmailTipValue ? 'block' : 'none',
      );
    }
  }

  private transform(value?: string | null, searchTerm?: string | null) {
    if (!value) {
      return '';
    }

    // pass value if no @ symbol
    if (!value.includes('@')) {
      return this.highlightText(value + searchTerm, value);
    }

    // slice value to get the part before @ symbol
    const [beforeAt] = value.split('@');

    return this.highlightText((beforeAt || '') + searchTerm, value);
  }

  private highlightText(value: string, searchTerm: string) {
    const start = value.toLowerCase().indexOf(searchTerm.toLowerCase());
    const end = start + searchTerm.length;

    // return value if searchTerm is not found
    if (start === -1) {
      return value;
    }

    const result =
      value.slice(0, start) +
      value.slice(start, end) +
      '<strong class="email-tip-strong">' +
      value.slice(end) +
      '</strong>';

    return result;
  }
}
